import { createApp } from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';

/**
 * Создаёт и маунтит vue-приложения на основе предоставленного массива
 * @param {Array} vueApps — массив объектов, где объект конфигурация для конкретного приложения
 * @param pinia Pinia - экземпляр хранилища pinia
 * @param {String} vueApps.obj.el — элемент, на который будет маунтиться приложение
 * @param {Object} vueApps.obj.components — компоненты, зарегистрированные для использования в приложении
 */
export default function vueAppInitiator(vueApps, pinia) {
    vueApps.forEach(({ el, components }) => {
        const mountWrapper = document.querySelector(el);
        if (!mountWrapper) { return false; }

        const app = createApp({
            components
        });

        app.use(VueAxios, axios);
        app.use(pinia);

        app.mount(el);
    });
}
